import { ComponentType, Ref } from 'react';

import { styled } from '@mui/material';

import { cssVars } from '../../../utils/cssVars';
import Chip, { ChipProps } from '../Chip';
import { tokens } from '../../../theme/generated/tokens';
import { Sizes } from '../../../types';

type LabelChipSize = Sizes<'2xs' | 'xs' | 'sm' | 'md' | 'lg'>;

export type LabelChipProps = Omit<ChipProps, 'size'> & {
  size?: LabelChipSize;
};

const { setValues } = cssVars({}, 'ds-chip');

const LabelChip = styled(
  Chip as ComponentType<LabelChipProps & { ref?: Ref<HTMLDivElement> }>,
  { target: 'LabelChip-root' }
)(({ size = 'md', theme }) => [
  {
    width: 'max-content',
    borderRadius: tokens.theme.radius.full,
    '& .DsChip-IconWrapper': {
      fontSize: '12px',
    },
  },
  size === '2xs' && {
    ...setValues({
      ...theme.typography.L10M,
      fontSize: '8px',
      px: '4px',
      gap: '2px',
      height: '10px',
    }),
    '& .DsChip-IconWrapper': {
      fontSize: '10px',
    },
  },
  size === 'xs' && {
    ...setValues({
      ...theme.typography.L10M,
      px: '6px',
      gap: '2px',
      height: '14px',
    }),
  },
  size === 'sm' && {
    ...setValues({
      ...theme.typography.L10M,
      height: '16px',
    }),
  },
  size === 'md' && {
    ...setValues({
      ...theme.typography.L10M,
      height: '20px',
    }),
  },
  size === 'lg' && {
    ...setValues({
      ...theme.typography.L12M,
      height: '24px',
    }),
    '& .DsChip-IconWrapper': {
      fontSize: '16px',
    },
  },
]);

export default LabelChip;
